import {
  Toolbar,
  Box,
  CssBaseline,
  Typography,
  IconButton,
  Badge,
  Chip,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Email,
  Home,
  Logout,
  Menu as MenuIcon,
  Notifications,
} from "@mui/icons-material";
import { CustomAppBar } from "./custom";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MenuItems } from "dashboard/configs";
import { signOut } from "firebase/auth";
import { auth } from "configs/firebaseConfigs";
import { useAppContext } from "contexts";
import { useMessages } from "hooks/useDataFetch";
import { useIsMounted } from "hooks";

const HeaderLayout = ({ handleDrawerOpen, isDrawerOpen }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [unReadMessage, setUnReadMessage] = useState(0);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const location = useLocation();
  const navigate = useNavigate();

  const { user } = useAppContext();
  const message = useMessages();
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted.current) {
      if (!message.data) return;
      const unreadMessage = message?.data?.filter(
        (message) => message?.read === false
      );
      setUnReadMessage(unreadMessage?.length);
    }
  }, [message.data, isMounted]);

  const handleLogout = async () => {
    try {
      signOut(auth)
        .then(() => {
          navigate("/", {});
        })
        .catch((error) => {
          // An error happened.
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <CssBaseline />
      <CustomAppBar
        position="fixed"
        style={{
          backgroundImage: "linear-gradient(200deg, #721382, #e44b64)",
        }}
        open={isDrawerOpen}
        elevation={0}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              mr: "36px",
              ...(isDrawerOpen && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap sx={{ textTransform: "capitalize" }}>
            {MenuItems.find((item) => item.route === location.pathname)?.title}
            {
              MenuItems.find((item) =>
                item?.submenus?.find(
                  (submenus) => submenus.route === location?.pathname
                )
              )?.title
            }
            {MenuItems.find((item) =>
              item?.submenus?.find(
                (submenus) => submenus.route === location?.pathname
              )
            )?.title ? (
              <span> / </span>
            ) : (
              <span> </span>
            )}
            {
              MenuItems.find((item) =>
                item?.submenus?.find(
                  (submenus) => submenus.route === location?.pathname
                )
              )?.submenus?.find(
                (submenus) => submenus.route === location?.pathname
              )?.title
            }{" "}
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          <IconButton sx={{ mr: 2 }} component={Link} to="/admin/messages">
            <Badge badgeContent={unReadMessage} color="error">
              <Email
                sx={{
                  color: "white",
                }}
              />
            </Badge>
          </IconButton>
          <IconButton sx={{ mr: 2 }} component={Link} to="/admin/notifications">
            <Badge badgeContent={0} color="error">
              <Notifications
                sx={{
                  color: "white",
                }}
              />
            </Badge>
          </IconButton>
          <Chip
            sx={{
              color: "#ffffff",
              borderWidth: "1px",
              borderColor: "#ffffff",
            }}
            onClick={handleClick}
            avatar={<Avatar alt="" src="/favicon.ico" />}
            label="Profile"
            variant="outlined"
          />
        </Toolbar>
      </CustomAppBar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          <Avatar alt="" src="/favicon.ico" />
          <ListItemText primary={user?.displayName} secondary={user?.email} />
        </MenuItem>
        <Divider />
        <MenuItem component={Link} to="/">
          <ListItemIcon>
            <Home fontSize="small" />
          </ListItemIcon>
          Back To Home
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleLogout();
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default HeaderLayout;
